import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GroupsListComponent } from './groups-list/groups-list.component';
import { GroupsDetailComponent } from './groups-detail/groups-detail.component';

const routes: Routes = [
    {
        path: 'groups',
        children: [
            { path: '', component: GroupsListComponent },
            { path: ':guid', component: GroupsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class GroupsRoutingModule { }
